import { Component, inject } from '@angular/core';
import { MenuSidebar } from './menu-sidebar/menu-sidebar';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { AppLayoutService } from '../app-layout.service';
import { AdminHeader } from './admin-header/admin-header';
import { ScrollPanel } from 'primeng/scrollpanel';
import { Drawer } from 'primeng/drawer';
import { toSignal } from '@angular/core/rxjs-interop';
import { filter, map, startWith } from 'rxjs';

@Component({
  standalone: true,
  selector: 'app-admin-layout',
  imports: [MenuSidebar, RouterOutlet, AdminHeader, ScrollPanel, Drawer],
  templateUrl: './admin-layout.html',
  styleUrl: './admin-layout.scss',
})
export class AdminLayout {
  private readonly _router = inject(Router);
  private readonly _route = inject(ActivatedRoute);

  sidebarService = inject(AppLayoutService);

  hideHeader = toSignal(
    this._router.events.pipe(
      filter((e) => e instanceof NavigationEnd),
      startWith(null),
      map(() => {
        let r = this._route;
        while (r.firstChild) r = r.firstChild;
        return !!r.snapshot.data['hideHeader'];
      }),
    ),
    { initialValue: false },
  );
}
